module.exports = __webpack_public_path__ + "files/125959bc93b18a90585687796de936ac.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/droidserif-italic-webfont.svg
 ** module id = 902
 ** module chunks = 0
 **/